<app-stepper-valider-elements [form]="form" [formulaireIntitule]="formulaireIntitule" [element]="false">
</app-stepper-valider-elements>
<div class="no-gutters">
  <div class="col-6">
    <div class="formulaire">
      <fieldset>
        <legend>{{ validerMessage.redactionAvis | translate }}</legend>
        <span>{{ validerMessage.denomination | translate }}</span>
        <ul>
          <li *ngIf="formExtractorService.getMapValue_ControlsID_ControlsIDWithoutStepIdCommonId(this.form).get('_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_denomination')">{{
            formExtractorService.getMapValue_ControlsID_ControlsIDWithoutStepIdCommonId(this.form).get('_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_denomination') }}</li>
        </ul>
      </fieldset>
    </div>
  </div>
</div>
